/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getListFeed.defs'
export { main as default } from './getListFeed.defs'
